export function genLetterSpaceConfig() {
    return ['1px', '2px', '3px', '4px', '5px', '6px']
}